import Vue from 'vue'
import Router from 'vue-router'
import Login_Pc from '@/components/pc/login'
import Jyjl_Pc from '@/components/pc/jyjl'
import JyjlFyMx_PC from '@/components/pc/jyjl-fymx'
import JyjlJyjl_PC from '@/components/pc/jyjl-jyjl'
import JyjlJcjl_PC from '@/components/pc/jyjl-jcjl'
import JyjlCf_PC from '@/components/pc/jyjl-cf'
import JyjlCfMx_PC from '@/components/pc/jyjl-cf-mx'
import JyjlYpyz_PC from '@/components/pc/jyjl-ypyz'
import JyjlJyjlMx_PC from '@/components/pc/jyjl-jyjl-mx'

import Login_Mobile from '@/components/mobile/login'
import Jyjl_Mobile from '@/components/mobile/jyjl'
import Mzjl_Mobile from '@/components/mobile/mzjl-xx'
import Zyjl_Mobile from '@/components/mobile/zyjl-xx'
import MzjlCf_Mobile from '@/components/mobile/mzjl-cf-xx'
import JyjlJyjlMx_Mobile from '@/components/mobile/jyjl-jyjl-xx'
import User_Mobile from '@/components/mobile/components/User'

Vue.use(Router)

let device = 'PC'
if(/Android|Windows Phone|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)){  //测试当前是哪个手机系统，可根据业务需要选择
    device = 'MOBILE'
}else if(/iPad/i.test(navigator.userAgent)){ // ipad
    //console.log("现在是平板端")
    device = 'MOBILE'
}

export default new Router({
  routes: [
      //通用
      {
          path: '/login',
          name: 'login',
          component: device == 'PC' ? Login_Pc : Login_Mobile
      },
      {
          path: '/',
          name: 'jyjl',
          component: device == 'PC' ? Jyjl_Pc : Jyjl_Mobile,
          //meta: { keepAlive: true }
      },

      //PC
      {
          path: '/jyjl/fymx/:from/:id',
          name: 'jyjl-fymx',
          component: JyjlFyMx_PC
      },
      {
          path: '/jyjl/jyjl/:from/:id',
          name: 'jyjl-jyjl',
          component: JyjlJyjl_PC
      },
      {
          path: '/jyjl/jyjl-mx/:pfrom/:pid/:id',
          name: 'jyjl-jyjl-mx',
          component: JyjlJyjlMx_PC
      },
      {
          path: '/jyjl/jcjl/:id',
          name: 'jyjl-jcjl',
          component: JyjlJcjl_PC
      },
      {
          path: '/jyjl/cf/:id',
          name: 'jyjl-cf',
          component: JyjlCf_PC
      },
      {
          path: '/jyjl/cf-mx/:pid/:id',
          name: 'jyjl-cf-mx',
          component: JyjlCfMx_PC
      },
      {
          path: '/jyjl/ypyz/:id',
          name: 'jyjl-ypyz',
          component: JyjlYpyz_PC
      },

      //移动端
      {
          path: '/mzjl/:row',
          name: 'mzjl',
          component: Mzjl_Mobile
      },
      {
          path: '/mzjl/cf/:row',
          name: 'mzjl-cf',
          component: MzjlCf_Mobile
      },
      {
          path: '/zyjl/:row',
          name: 'zyjl',
          component: Zyjl_Mobile
      },
      {
          path: '/m-jyjl/jyjl/xx/:row',
          name: 'm-jyjl-jyjl-xx',
          component: JyjlJyjlMx_Mobile
      },
      {
          path: '/user',
          name: 'user',
          component: User_Mobile
      },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js